import {
  put, takeLatest, takeEvery, select, all,
} from 'redux-saga/effects';
import {
  TeammoApi,
  normalize,
  compilePaginationObject,
} from 'app/utils/redux/helpers';
import { teamMemberSchema, teamMemberListSchema } from 'app/utils/redux/schemas';
import { handleError } from 'app/utils/handlers/handleError';
import {
  loadingStart,
  loadingFinish,
  actionConfirmed,
} from 'app/ducks/loading/actions';
import {
  sagaActions,
} from 'app/ducks/teamMembers/actions';
import { TeamMembersActionTypes as types } from 'app/ducks/teamMembers/types';

function* createTeamMemberSaga(action): any {
  yield put(sagaActions.createTeamMemberPending(action.payload));
  const [error, response] = yield (yield TeammoApi(yield select())).teamMembers.create(
    action.payload,
  );

  if (response) {
    const normalizedResponse = normalize(response, teamMemberSchema);

    yield put(sagaActions.createTeamMemberSuccess(normalizedResponse));
  } else {
    yield put(
      handleError(
        error,
        sagaActions.createTeamMemberFailed(_.isEmpty(error) ? {} : error.response.data.errors),
      ),
    );
  }
}

function* updateTeamMemberSaga(action): any {
  yield put(sagaActions.updateTeamMemberPending(action.payload));
  const [error, response] = yield (yield TeammoApi(yield select())).teamMembers.update(
    action.payload,
  );

  if (response) {
    const normalizedResponse = normalize(response, teamMemberSchema);

    yield put(sagaActions.updateTeamMemberSuccess(normalizedResponse));
  } else {
    yield put(
      handleError(
        error,
        sagaActions.updateTeamMemberFailed(_.isEmpty(error) ? {} : error.response.data.errors),
      ),
    );
  }
}

function* deleteTeamMemberSaga(action): any {
  yield put(sagaActions.deleteTeamMemberPending(action.payload.teamMember.id));
  const [error, response] = yield (yield TeammoApi(yield select())).teamMembers.delete(
    action.payload.teamMember,
  );

  if (response || _.isEmpty(error)) {
    // const normalizedResponse = normalize(response, teamMemberSchema);
    yield put(actionConfirmed('Team member deleted'));
    yield put(sagaActions.deleteTeamMemberSuccess(action.payload.teamMember.id));
    if (action.payload.callbackFunction !== undefined) {
      action.payload.callbackFunction();
    }
  } else {
    yield put(
      handleError(
        error,
        sagaActions.deleteTeamMemberFailed(
          _.isEmpty(error) ? {} : error.response.data.errors,
        ),
      ),
    );
  }
}

function* getTeamMemberSaga(action): any {
  yield put(sagaActions.getTeamMemberPending());
  const [error, response] = yield (yield TeammoApi(yield select())).teamMembers.show(
    action.payload,
  );
  if (response) {
    const normalizedResponse = normalize(response, teamMemberSchema);
    yield put(sagaActions.getTeamMemberSuccess(normalizedResponse));
    return normalizedResponse.entities.teamMembers[normalizedResponse.result];
  }
  yield put(
    handleError(error, sagaActions.getTeamMemberFailed(_.isEmpty(error) ? {} : error.response.data.errors)),
  );
  return null;
}

function* getAllTeamMembersSaga(action): any {
  yield put(
    sagaActions.getAllTeamMembersPending(action.payload.compile ? action.payload.pagination : {}),
  );
  yield put(loadingStart());

  const paginationObject = action.payload.compile
    ? compilePaginationObject(yield select((state) => state.teamMembers.pagination))
    : action.payload.pagination;
  let teammoApi = TeammoApi(yield select());

  if (action.payload.teamMemberView) {
    teammoApi = TeammoApi(yield select(), null, null, false, false, {
      'team-member-code': action.payload.teamMemberCode,
      'team-code': action.payload.teamCode,
    });
  }
  const [error, response] = yield (yield teammoApi).teamMembers.list(
    paginationObject,
  );

  if (response) {
    const normalizedResponse = normalize(response, teamMemberListSchema);

    yield put(
      sagaActions.getAllTeamMembersSuccess(normalizedResponse, response.meta),
    );
    yield put(loadingFinish());
  } else {
    yield put(error, sagaActions.getAllTeamMembersFailed(_.isEmpty(error) ? {} : error.response.data.errors));
  }
}

/* ********************************* SAGA WATCHERS ********************************* */

function* createTeamMemberSagaWatcher(): any {
  yield takeLatest(types.CREATE_TEAM_MEMBER_REQUESTED, createTeamMemberSaga);
}

function* updateTeamMemberSagaWatcher(): any {
  yield takeLatest(types.UPDATE_TEAM_MEMBER_REQUESTED, updateTeamMemberSaga);
}

function* deleteTeamMemberSagaWatcher(): any {
  yield takeLatest(types.DELETE_TEAM_MEMBER_REQUESTED, deleteTeamMemberSaga);
}

function* getTeamMemberSagaWatcher(): any {
  yield takeLatest(types.GET_TEAM_MEMBER_REQUESTED, getTeamMemberSaga);
}

function* getAllTeamMembersSagaWatcher(): any {
  yield takeLatest(types.GET_ALL_TEAM_MEMBERS_REQUESTED, getAllTeamMembersSaga);
}

export default function* root(): any {
  yield all([
    createTeamMemberSagaWatcher(),
    updateTeamMemberSagaWatcher(),
    deleteTeamMemberSagaWatcher(),
    getTeamMemberSagaWatcher(),
    getAllTeamMembersSagaWatcher(),
  ]);
}
